import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import defaultTheme from "../../../../theme/theme-test-override";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { remCalc } from "../../../../theme/style-utils-coras-nua";
import styled from "styled-components";

const StyledSlider = styled(Slider)`
    align-content: center;
    justify-content: center;
    border: ${remCalc(1)} solid ${props => props.theme.colors.backgroundLightest};
    padding: ${remCalc(24)} ${remCalc(48)};
    margin-bottom: ${remCalc(32)};
    background-size: contain;
    background-position: center center;
    max-height: ${remCalc(300)};
    background-repeat: no-repeat;
    min-height: ${remCalc(1)};
    max-width: 100%;
    .slick-list {
    }
    .slick-slide {
        > div {
            padding: 0 ${remCalc(4)};
            margin: 0 -${remCalc(2)};
            text-align: center;
        }
        img {
            max-width: 100%;
            object-fit: contain;
            flex: 0 0 100%;
            max-height: ${remCalc(250)};
            width: inherit !important;
        }
    }
`;

StyledSlider.defaultProps = {
    theme: {
        ...defaultTheme
    }
};
const StyledNextArrow = styled(FaChevronLeft)`
    color: ${props => props.theme.colors.backgroundLightest};
    &:hover {
        color: ${props => props.theme.colors.primary};
    }
    position: absolute;
    left: ${remCalc(16)};
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
`;

StyledNextArrow.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

const StyledPrevArrrow = styled(FaChevronRight)`
    color: ${props => props.theme.colors.backgroundLightest};
    &:hover {
        color: ${props => props.theme.colors.primary};
    }
    position: absolute;
    right: ${remCalc(16)};
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
`;

StyledPrevArrrow.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

function NextArrow(props) {
    const { onClick } = props;
    return <StyledPrevArrrow onClick={onClick} />;
}
function PrevArrow(props) {
    const { onClick } = props;
    return <StyledNextArrow onClick={onClick} />;
}
export default ({ ...props }) => {
    let sliderObj = null;

    const changeImageEffect = (prevLength, generatedFilesLength) => () => {
        if (generatedFilesLength > 0 && prevLength <= generatedFilesLength) {
            sliderObj.slickGoTo(generatedFilesLength - 1);
        }
    };

    const usePrevious = value => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });

        return ref.current;
    };

    const generatedFilesLength = props.generatedFiles.length;
    const prevLength = usePrevious(props.generatedFiles.length);

    useEffect(changeImageEffect(prevLength, generatedFilesLength), [
        sliderObj,
        generatedFilesLength
    ]);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    };

    return (
        <StyledSlider
            className="file-preview-slider"
            {...settings}
            ref={slider => (sliderObj = slider)}>
            {props.generatedFiles.map((uploadedFileData, key) => {
                if (uploadedFileData.url) {
                    return (
                        <img
                            key={key}
                            src={uploadedFileData.url.replace(
                                /^(javascript:)/,
                                ""
                            )}
                            alt={props.description}
                        />
                    );
                } else if (uploadedFileData.message) {
                    return <p key={key}>{uploadedFileData.message}</p>;
                }

                return <p key={key}>Unable to generate preview</p>;
            })}
        </StyledSlider>
    );
};
